module.exports = __webpack_public_path__ + "img/Murmeli3.67714e93.gif";